import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Home from "./Pages/HomePage";
import AboutUsPage from "./Pages/AboutUs";
import FAQ from "./Pages/FAQ";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import ContactUs from "./Pages/ContactUs";
import Sapcotent from "./Pages/Sapcotent";
import ExchangePage from "./Pages/Exchange";
import Navbar from "./Components/Navbar";
import ArcherPage from "./Pages/Archer";
import ProjectDetail from "./Pages/ProjectDetails/ProjectDetail";
import Service from "./Pages/Servicepage/Service";
import Aboutpage from "./Pages/Aboutpage/Aboutpage";
import Contactpage from "./Pages/Contactpage/ContactUs";
import Footer from "./Components/Footer/Footer";
import Foodarna from "./Pages/Foodarna/Foodarna";
import Developpage from "./Pages/Servicepage/Developpage/Developpage";
import Sappage from "./Pages/Servicepage/Servicestep/Sappage/Sappage";
import Cloudpage from "./Pages/Servicepage/Cloudpage/Cloudpage";
import Generativepage from "./Pages/Servicepage/Generativepage/Generativepage";
import Itservices from "./Pages/Servicepage/Itservices/Itservices";
import Itconsulting from "./Pages/Servicepage/Itconsulting/Itconsulting";
import TermAndCondition from "./Pages/TermsAndCondition";
import ShopifyStripe from "./Pages/ShopifyStripe/ShopifyStripe";
import Testitude from "./Pages/Testitude/Testitude";

const App = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/service" element={<Service />} />
        <Route path="/prodetail" element={<ProjectDetail />} />
        <Route path="/prodetail" element={<ProjectDetail />} />
        <Route path="/about" element={<Aboutpage />} />
        <Route path="/contact" element={<Contactpage />} />
        <Route path="/foodrana" element={<Foodarna />} />
        <Route path="/shopify-stripe" element={<ShopifyStripe />} />
        <Route path="/testitude" element={<Testitude />} />
        <Route path="/servicepage/mobileappandwebdevelopment" element={<Developpage />} />
        <Route path="/servicepage/cloudservices" element={<Cloudpage />} />
        <Route path="/servicepage/sapimplementation" element={<Sappage />} />
        <Route path="/servicepage/generativeai" element={<Generativepage />} />
        <Route path="/servicepage/itservices" element={<Itservices />} />
        <Route path="/servicepage/itconsulting" element={<Itconsulting />} />
        <Route path="term-condition" element={<TermAndCondition />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      <footer className="footer-bg-change">
        <Footer />
      </footer>
    </>
  );
};

export default App;
